import moment from 'moment';
import { startCase } from 'lodash';

import {
  ADD_LEAD, FETCH_LEADS, REMOVE_LEAD, UPDATE_LEAD, UPDATE_LEADS,
  APPROVE_LEAD_VAULT_ACCESS, REVOKE_LEAD_VAULT_ACCESS,
  BLOCK_LEAD_VAULT_ACCESS, UNBLOCK_LEAD_VAULT_ACCESS, FETCH_LEADS_LOADING
} from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
  case ADD_LEAD:
    return [action.payload, ...state];
  case FETCH_LEADS_LOADING:
    return { fetching: true };
  case FETCH_LEADS:
    return action.payload;
  case REMOVE_LEAD:
    return state.filter(lead => lead.id !== action.payload);
  case UPDATE_LEAD: {
    const updatedLead = action.payload;
    return state.map(lead => lead.id === updatedLead.id ? { ...updatedLead } : { ...lead });
  }
  case APPROVE_LEAD_VAULT_ACCESS: {
    const { updatedLeadId, propertyVaultProfileId } = action.payload;
    return changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.APPROVED);
  }
  case REVOKE_LEAD_VAULT_ACCESS: {
    const { updatedLeadId, propertyVaultProfileId } = action.payload;
    return changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.REVOKED);
  }
  case BLOCK_LEAD_VAULT_ACCESS: {
    const { updatedLeadId, propertyVaultProfileId } = action.payload;
    return changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.BLOCKED);
  }
  case UNBLOCK_LEAD_VAULT_ACCESS: {
    const { updatedLeadId, propertyVaultProfileId } = action.payload;
    return changeLeadVaultAccess(
      state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.PENDING_APPROVAL
    );
  }
  case UPDATE_LEADS: {
    let newState = [...state];
    action.payload.forEach((updatedLead) => {
      newState = newState.map(lead => lead.id === updatedLead.id ? { ...updatedLead } : { ...lead });
    });
    return newState;
  }
  default:
    return state;
  }
}

export const LEAD_VAULT_ACCESS_TYPES = {
  AUTO_APPROVED: 'auto_approved',
  APPROVED: 'approved',
  BLOCKED: 'blocked',
  PENDING_APPROVAL: 'pending_approval',
  REVOKED: 'revoked'
};

export const CAN_APPROVE_LEAD_VAULT_ACCESS_TYPES = [
  LEAD_VAULT_ACCESS_TYPES.PENDING_APPROVAL,
  LEAD_VAULT_ACCESS_TYPES.REVOKED,
];

export const CAN_REVOKE_LEAD_VAULT_ACCESS_TYPES = [
  LEAD_VAULT_ACCESS_TYPES.AUTO_APPROVED,
  LEAD_VAULT_ACCESS_TYPES.APPROVED,
];

export const CAN_UNBLOCK_LEAD_VAULT_ACCESS_TYPES = [
  LEAD_VAULT_ACCESS_TYPES.BLOCKED
];

export function changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, newApprovalState) {
  return state.map((lead) => {
    const newLeadObject = { ...lead };

    if (newLeadObject.id !== updatedLeadId) return newLeadObject;

    newLeadObject.propertyVaultProfiles = newLeadObject.propertyVaultProfiles.map((propertyVaultProfile) => {
      if (propertyVaultProfile.id !== propertyVaultProfileId) return { ...propertyVaultProfile };

      const newStatusLabel = startCase(newApprovalState);
      return { ...propertyVaultProfile, approvalState: newApprovalState, waitlistStatusLabel: newStatusLabel };
    });
    newLeadObject.updatedAt = moment().toISOString();
    newLeadObject.approvalStatus = getLeadApprovalStatus(newLeadObject);

    return newLeadObject;
  });
}

export function changeMatchingContactLeadsVaultAccess(state, updatedLead, newApprovalState) {
  return state.map((lead) => {
    const newLeadObject = { ...lead };

    if (newLeadObject.emailAddress !== updatedLead.emailAddress) return newLeadObject;

    newLeadObject.propertyVaultProfiles = newLeadObject.propertyVaultProfiles.map((propertyVaultProfile) => {
      const newStatusLabel = startCase(newApprovalState);
      return { ...propertyVaultProfile, approvalState: newApprovalState, waitlistStatusLabel: newStatusLabel };
    });
    newLeadObject.updatedAt = moment().toISOString();

    return newLeadObject;
  });
}

// This function should mimic ProjectLeadDecorator#approval_status code.
function getLeadApprovalStatus(lead) {
  const allStatuses = lead.propertyVaultProfiles.map(pvp => pvp.approvalState);
  return APPROVAL_STATUSES.find(state => allStatuses.includes(state));
}

// Order is important
export const APPROVAL_STATUSES = ['pending_approval', 'approved', 'revoked'];